import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";
import { InfoCard } from "../../../../components/info-card/components/info-card/info-card.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faThLarge } from "@fortawesome/free-solid-svg-icons";
import { BriefListViewType } from "../../types/brief-list-view-type.enum";
import React from "react";
import { BriefListTable } from "../brief-list-table/brief-list-table.component";
import { BriefListTodayProps } from "./brief-list-today.props";
import { Grid, Radio } from "@material-ui/core";
import { TodayHeader, ViewLabel } from "./brief-list-today.styles";

export const BriefListToday = withShowIf((props: BriefListTodayProps) => {
  const handleViewChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    props.onViewChange(event.target.value as BriefListViewType);

  return (
    <>
      <div>
        <TodayHeader
          variant={"h2"}
          style={{
            marginBottom: props.viewType === BriefListViewType.GRID_VIEW ? "0" : "-40px",
          }}
        >
          Today
          <ViewLabel htmlFor={BriefListViewType.GRID_VIEW}>Grid View</ViewLabel>
          <Radio
            inputProps={{ "aria-label": "Grid View" }}
            id={BriefListViewType.GRID_VIEW}
            value={BriefListViewType.GRID_VIEW}
            checked={props.viewType === BriefListViewType.GRID_VIEW}
            style={{ width: "fit-content", marginLeft: "16px" }}
            checkedIcon={<FontAwesomeIcon icon={faThLarge} size="xs" color="deepSkyBlue" />}
            icon={<FontAwesomeIcon icon={faThLarge} size="xs" />}
            onChange={handleViewChange}
          />
          <ViewLabel htmlFor={BriefListViewType.LIST_VIEW}>List View</ViewLabel>
          <Radio
            inputProps={{ "aria-label": "List View" }}
            id={BriefListViewType.LIST_VIEW}
            value={BriefListViewType.LIST_VIEW}
            checked={props.viewType === BriefListViewType.LIST_VIEW}
            style={{ width: "fit-content" }}
            checkedIcon={<FontAwesomeIcon icon={faList} size="xs" color="deepSkyBlue" />}
            icon={<FontAwesomeIcon icon={faList} size="xs" />}
            onChange={handleViewChange}
          />
        </TodayHeader>
        {props.viewType === BriefListViewType.GRID_VIEW && <div style={{ margin: "20px" }} />}
        <Grid container direction="row" alignItems="flex-start">
          {props.viewType === BriefListViewType.GRID_VIEW &&
            props.todayList.map((briefData) => {
              return (
                <InfoCard key={briefData.id} briefData={briefData} briefType={props.briefType} />
              );
            })}
        </Grid>
      </div>
      {props.viewType === BriefListViewType.GRID_VIEW ? (
        <>
          <div style={{ margin: "50px" }} />
          <BriefListTable key="gridView" dataList={props.gridList} briefType={props.briefType} />
        </>
      ) : (
        <>
          <BriefListTable key="listView" dataList={props.listList} briefType={props.briefType} />
        </>
      )}
    </>
  );
});
